import { Skeleton, Stack } from '@mui/material';

import { FC } from 'react';

export const ChartSkeleton: FC = () => {
  return (
    <Stack
      alignItems='flex-end'
      direction='row'
      height={330}
      justifyContent='center'
      p={4}
      spacing={2}>
      <Stack spacing={2} width={40}>
        <Skeleton height={24} variant='text' width='100%' />
        <Skeleton height={162} variant='rectangular' width='100%' />
        <Skeleton height={24} variant='text' width='100%' />
      </Stack>
      <Stack alignItems='center' spacing={2} width={40}>
        <Skeleton height={24} variant='text' width='100%' />
        <Skeleton height={217} variant='rectangular' width='100%' />
        <Skeleton height={24} variant='text' width='100%' />
      </Stack>
      <Stack alignItems='center' spacing={2} width={40}>
        <Skeleton height={24} variant='text' width='100%' />
        <Skeleton height={185} variant='rectangular' width='100%' />
        <Skeleton height={24} variant='text' width='100%' />
      </Stack>
      <Stack alignItems='center' spacing={2} width={40}>
        <Skeleton height={24} variant='text' width='100%' />
        <Skeleton height={202} variant='rectangular' width='100%' />
        <Skeleton height={24} variant='text' width='100%' />
      </Stack>
      <Stack alignItems='center' spacing={2} width={40}>
        <Skeleton height={24} variant='text' width='100%' />
        <Skeleton height={150} variant='rectangular' width='100%' />
        <Skeleton height={24} variant='text' width='100%' />
      </Stack>
    </Stack>
  );
};
ChartSkeleton.displayName = 'ChartSkeleton';
